// src/socket.js

import { io } from "socket.io-client";

const SOCKET_URL =
  process.env.REACT_APP_API_BASE_URL ||
  "http://localhost:5003";

export const socket = io(SOCKET_URL, {
  transports: ["websocket"],
  autoConnect: false, // kita connect manual
  reconnection: true,
  reconnectionAttempts: 10,
  reconnectionDelay: 2000,
});
